module.exports = __webpack_public_path__ + "2c68ee315f0d61ac6fa37e25d7dda968.svg";